<div
  [ngClass]="{'row-responsive': is_responsive == true, 'row':true, 'row_main':is_responsive == false, 'animate__animated':true, 'animate__fadeIn':true}">


  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" style="position: relative;">
    <div class="row">

      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
        <span class="material-icons" (click)="return()" style="cursor: pointer;">
          keyboard_return
        </span>
      </div>


      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
        <h1 class="titulo-simpli" style="margin-top: 0px !important;text-align: center;">Revisa el detalle de tu simulación</h1>
      </div>
    </div>
  </div>


  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">

    <div class="row">

      <div class="col-lg-3 col-md-2 col-sm-1 col-xs-12"></div>

      <div class="col-lg-6 col-md-8 col-sm-10 col-xs-12">
        <mat-card id="card-simulation" class="card-tabla">



          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top animate__animated animate__fadeIn">

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                <div class="caja-rosa animate__animated animate__fadeIn" *ngIf="cantidad_facturas <= 7">

                  <h1 class="titulo-interno">Facturas de la simulación</h1>

                  <div class="contenedor-facturas add_factoring">


                    <div class="row" style="margin-bottom: 5px;">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Cantidad de facturas:</div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="font-weight: bold;text-align: right;">
                        @if(loading_cantidad){
                        <skeleton-loader></skeleton-loader>
                        }@else{
                        {{cantidad_facturas}}
                        }
                      </div>

                    </div>

                    <div>
                      <div style="text-align: right;">
                        <mat-label class="pink-label" (click)="detalle_factura()">Abrir detalle <i
                            class="fa-solid fa-angle-right"></i></mat-label>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="caja-rosa animate__animated animate__fadeIn" style="padding-left: 0px;"
                  *ngIf="cantidad_facturas == 0 && loading == true">

                  <div style="text-align: center;margin-top: 20px;margin-bottom: 20px;">
                    <i style="color: gray; font-size: 25px;" class="fa-solid fa-spinner fa-spin-pulse"></i>
                  </div>

                </div>

              </div>

            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                <div class="box-info-facturas">
                  <div class="titulo-interno">Montos asociados</div>

                  <div>
                    <div class="row row-montos">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Monto total simulado:</div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                        @if(loading){
                        <skeleton-loader></skeleton-loader>
                        }@else{
                        ${{total}}
                        }
                      </div>
                    </div>
                    <div class="row row-montos">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Porcentaje de financiamiento:</div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                        @if(loading){
                        <skeleton-loader></skeleton-loader>
                        }@else{
                        {{anticipo}}%
                        }
                      </div>
                    </div>
                    <div class="row row-montos">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Monto de anticipo:</div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                        @if(loading){
                        <skeleton-loader></skeleton-loader>
                        }@else{
                        ${{valor_anticipo_total}}
                        }
                      </div>
                    </div>
                    <div class="row row-montos">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Vencimiento:</div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                        @if(loading){
                        <skeleton-loader></skeleton-loader>
                        }@else{
                        {{dias_promedio}} días
                        }
                      </div>
                    </div>

                    @if(expandir) {
                    <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Tasa de interés:</div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                        @if(loading){
                        <skeleton-loader></skeleton-loader>
                        }@else{
                        {{tasa_interes}}%
                        }
                      </div>
                    </div>

                    <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Monto total de interés:</div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                        @if(loading){
                        <skeleton-loader></skeleton-loader>
                        }@else{
                        ${{interes_total}}
                        }
                      </div>
                    </div>

                    <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Comisión:</div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                        @if(loading){
                        <skeleton-loader></skeleton-loader>
                        }@else{
                        ${{comision}}
                        }
                      </div>
                    </div>

                    <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Gastos operacionales:</div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                        @if(loading){
                        <skeleton-loader></skeleton-loader>
                        }@else{
                        ${{gastos}}
                        }
                      </div>
                    </div>

                    <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Diferencia de precios:</div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                        @if(loading){
                        <skeleton-loader></skeleton-loader>
                        }@else{
                        ${{interes_total}}
                        }
                      </div>
                    </div>

                    <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">IVA:</div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                        @if(loading){
                        <skeleton-loader></skeleton-loader>
                        }@else{
                        ${{iva_operacion}}
                        }
                      </div>
                    </div>

                    <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Excedentes:</div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                        @if(loading){
                        <skeleton-loader></skeleton-loader>
                        }@else{
                        ${{excedentes}}
                        }
                      </div>
                    </div>

                    <div class="row row-montos animate__animated  animate__faster animate__fadeIn">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">Costo de apertura:</div>
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="text-align: right;font-weight: bold;">
                        @if(loading){
                        <skeleton-loader></skeleton-loader>
                        }@else{
                        ${{settings.formatMoney(98500)}}
                        }
                      </div>
                    </div>
                    }



                    <div (click)="expandir = !expandir"
                      style="display: flex;justify-content: center;align-items: center;gap: 10px;color: gray;font-size: 13px;cursor: pointer;">
                      @if(expandir){
                      contraer
                      }@else{
                      expandir
                      }
                      <span *ngIf="expandir == false">
                        <i style="font-size: 16px;" class="fa-solid fa-chevron-down"></i>
                      </span>
                      <span *ngIf="expandir == true">
                        <i style="font-size: 16px;" class="fa-solid fa-chevron-up"></i>
                      </span>

                    </div>


                  </div>


                </div>

              </div>

            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                <div class="caja-rosa" style="padding-top: 15px;padding-bottom: 15px;">

                  <div class="forfacturas" style="margin-bottom: 0px;">

                    <div class="rowfacturas2">
                      <div class="titulo-interno" style="margin-bottom: 0px !important;">Monto líquido:</div>
                    </div>

                    <div class="rowfacturas">
                      <div class="strong-facturas2" style="margin-left: 50px;">${{monto_recibir}}</div>
                    </div>

                  </div>

                </div>

              </div>

            </div>

            <div class="contact-container" style="margin-top: 10px;">
              <div class="icons">
                @if(loading_pdf_ == false){
                <span (click)="download_pdf()"><i class="fa-sharp fa-light fa-download"></i>Descargar simulación</span>
                }@else{
                <span style="opacity: 0.5;"><i class="fa-solid fa-circle-notch fa-spin"></i> Descagar simulación</span>
                }
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                <div class="btn-simpli-container">
                  <button class="primary-button" mat-flat-button (click)="files()">
                    <mat-label>Ver documentación</mat-label>
                  </button>

                  <button class="secondary-button" mat-flat-button (click)="volver()">
                    <mat-label>Volver</mat-label>
                  </button>
                </div>

              </div>
            </div>
          </div>



        </mat-card>
      </div>

      <div class="col-lg-3 col-md-2 col-sm-1 col-xs-12"></div>

    </div>

  </div>

</div>